// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DropdownFixedController from "./dropdown_fixed_controller"
application.register("dropdown-fixed", DropdownFixedController)

import DropdownSelectController from "./dropdown_select_controller"
application.register("dropdown-select", DropdownSelectController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FloatingLabelController from "./floating_label_controller"
application.register("floating-label", FloatingLabelController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import LoginModalController from "./login_modal_controller"
application.register("login-modal", LoginModalController)

import PrintDialogController from "./print_dialog_controller"
application.register("print-dialog", PrintDialogController)

import QuantityStepperController from "./quantity_stepper_controller"
application.register("quantity-stepper", QuantityStepperController)

import SlideToggleController from "./slide_toggle_controller"
application.register("slide-toggle", SlideToggleController)

import TagFilterController from "./tag_filter_controller"
application.register("tag-filter", TagFilterController)

import TagManagerController from "./tag_manager_controller"
application.register("tag-manager", TagManagerController)

import TagOwnerToggleController from "./tag_owner_toggle_controller"
application.register("tag-owner-toggle", TagOwnerToggleController)

import UserFilterController from "./user_filter_controller"
application.register("user-filter", UserFilterController)

import ViewZeroToggleController from "./view_zero_toggle_controller"
application.register("view-zero-toggle", ViewZeroToggleController)
